import { Action, ActionReducer, combineReducers } from '@ngrx/store';
import { ShopsView } from '../../../_generated';
import { RequestStatus } from '../../actionstypes/request-status/request-status.actiontype';
import { ShopsRequestStatusAction } from '../../actionstypes/shops/shops-request-status.actiontype';
import requestStatusReducer from '../request-status/request-status.reducer';
import shopsReducer from './shops.reducer';

export interface RootShops {
  requestStatus: RequestStatus;
  data: ShopsView[];
}

export const shopsRootReducer = combineReducers({
  requestStatus: requestStatusReducer(ShopsRequestStatusAction.Load, ShopsRequestStatusAction.Success, ShopsRequestStatusAction.Error),
  data: shopsReducer as ActionReducer<ShopsView[], Action<string>>,
});
